<template>
  <div class="app-wrapper">
    <!-- 左侧菜单 -->
    <div class="sidebar-container">
      <div class="logo">资产管理系统</div>
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="#304156"
        text-color="#fff"
        active-text-color="#409EFF"
        :collapse="isCollapse"
      >
        <template v-for="menu in currentMenuList">
          <!-- 有子菜单的情况 -->
          <el-submenu 
            v-if="menu.children && menu.children.length" 
            :key="menu.path"
            :index="menu.path"
          >
            <template slot="title">
              <i :class="menu.icon"></i>
              <span>{{ menu.title }}</span>
            </template>
            <el-menu-item 
              v-for="subMenu in menu.children"
              :key="subMenu.path"
              :index="subMenu.path"
              @click="handleMenuClick(subMenu)"
            >
              {{ subMenu.title }}
            </el-menu-item>
          </el-submenu>
          
          <!-- 没有子菜单的情况 -->
          <el-menu-item 
            v-else 
            :key="menu.path"
            :index="menu.path"
            @click="handleMenuClick(menu)"
          >
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="main-container">
      <!-- 顶部导航 -->
      <div class="navbar">
        <div class="hamburger" @click="toggleSidebar">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item, index) in breadcrumbList" 
            :key="index">{{ item }}</el-breadcrumb-item>
        </el-breadcrumb>
        
        <!-- 用户操作区 -->
        <div class="user-container">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="avatar-wrapper">
              <i class="el-icon-user" style="margin-right: 5px;"></i>
              <span style="margin-right: 5px;">{{ userInfo.username }}</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      
      <!-- 内容区 -->
      <div class="app-main">
          <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from '@/config/menuConfig'

export default {
  name: 'Layout',
  computed: {
    userInfo() {
      const data = JSON.parse(localStorage.getItem('userInfo'))
      return data || {}
    },
    currentMenuList () {
      let permissionList = localStorage.getItem('permissionList')
      if (permissionList) {
        permissionList = JSON.parse(permissionList)
        // 根据权限列表，过滤出当前用户拥有的菜单
        const current = []
        menuList.forEach(item => {
          if (item.children) {
            const hello = []
            item.children.forEach(child => {
              if (permissionList.includes(child.code)) {
                hello.push(child)
              }
            })
            if (hello.length > 0) {
              current.push({
                ...item,
                children: hello
              })
            }
          }
          if (permissionList.includes(item.code)) {
            current.push(item)
          }
        })
        return current
      } else {
        return []
      }
    }
  },
  data() {
    return {
      menuList,
      isCollapse: false,
      breadcrumbList: [],
      activeMenu: '/dashboard'
    }
  },
  watch: {
    $route: {
      handler(route) {
        // 更新面包屑
        this.breadcrumbList = route.meta?.breadcrumb || []
        // 更新激活菜单
        this.activeMenu = route.path
      },
      immediate: true
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapse = !this.isCollapse
    },
    handleMenuClick(menu) {
      if (menu.path && this.$route.path !== menu.path) {
        this.$router.push(menu.path)
      }
    },
    // 处理用户下拉菜单命令
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await this.$http.post('/asset/admin/user/logout')
          // 清除用户信息和token
          localStorage.removeItem('userInfo')
          localStorage.removeItem('token')
          // 跳转到登录页
          this.$router.push('/login')
          this.$message.success('退出成功')
        } catch (error) {
          this.$message.error('退出失败，请重试')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;

  .sidebar-container {
    width: 210px;
    height: 100%;
    background-color: #304156;
    transition: width 0.3s;
    overflow: hidden;

    &.collapse {
      width: 54px;
    }

    .logo {
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #1f2d3d;
    }

    .sidebar-menu {
      border: none;
      height: calc(100% - 50px);
      width: 100%;
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .navbar {
      height: 50px;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,21,41,.08);
      display: flex;
      align-items: center;
      padding: 0 15px;

      .hamburger {
        padding: 0 15px;
        cursor: pointer;
        font-size: 20px;
        
        &:hover {
          color: #409EFF;
        }
      }

      // 用户操作区样式
      .user-container {
        margin-left: auto;
        padding-right: 15px;
        
        .avatar-wrapper {
          cursor: pointer;
          padding: 0 8px;
          
          .el-icon-user {
            font-size: 20px;
            vertical-align: middle;
          }
          
          .el-icon-caret-bottom {
            font-size: 12px;
            margin-left: 5px;
          }

          &:hover {
            color: #409EFF;
          }
        }
      }
    }

    .app-main {
      flex: 1;
      padding: 15px;
      overflow: auto;
      background: #f0f2f5;
    }
  }
}

// 菜单样式优化
/deep/ .el-menu {
  border-right: none;
  
  .el-menu-item, .el-submenu__title {
    height: 50px;
    line-height: 50px;
    
    &:hover {
      background-color: #263445 !important;
    }
  }

  .el-menu-item.is-active {
    background-color: #263445 !important;
  }
}
</style>
